import React from "react";
import { motion } from "framer-motion";

const variants = {
  up: { hidden: { opacity: 0, y: 36 }, show: { opacity: 1, y: 0 } },
  fade: { hidden: { opacity: 0 }, show: { opacity: 1 } },
  scale: { hidden: { opacity: 0, scale: 0.94 }, show: { opacity: 1, scale: 1 } },
  left: { hidden: { opacity: 0, x: -40 }, show: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: 40 }, show: { opacity: 1, x: 0 } },
};

export const Reveal = ({ children, variant = "up", delay = 0, className = "", once = true, amount = 0. }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once, amount }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    variants={variants[variant]}
  >
    {children}
  </motion.div>
);

// Staggered container + item
export const Stagger = ({ children, className = "", delayChildren = 0.05, stagger = 0.08, once = true }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once, amount: 0. }}
    variants={{ show: { transition: { staggerChildren: stagger, delayChildren } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", variant = "up" }) => (
  <motion.div
    className={className}
    variants={variants[variant]}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// word-by-word split text headline
export const SplitText = ({ text, className = "", delay = 0 }) => {
  const words = text.split(" ");
  return (
    <motion.span
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.4 }}
      variants={{ show: { transition: { staggerChildren: 0.045, delayChildren: delay } } }}
    >
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom pb-[0.18em] -mb-[0.18em]">
          <motion.span
            className="inline-block"
            variants={{ hidden: { y: "110%", opacity: 0 }, show: { y: "0%", opacity: 1 } }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
